
//
export const FETCH_MALL_BANNER_DATA = 'FETCH_MALL_BANNER_DATA'
export const FETCH_MALL_BANNER_SUCCESS = 'FETCH_MALL_BANNER_SUCCESS'

///
// 分类
export const REQUEST_CATALOG_DATA = 'REQUEST_CATALOG_DATA'
export const SET_CATALOG_DATA = 'SET_CATALOG_DATA'
export const SET_CATALOG_STATE = 'SET_CATALOG_STATE'

// 热销
export const REQUEST_HOT_SALE_DATA = 'REQUEST_HOT_SALE_DATA'
export const SET_HOT_SALE_DATA = 'SET_HOT_SALE_DATA'
export const SET_HOT_SALE_STATE = 'SET_HOT_SALE_STATE'

// 首页商品
export const REQUEST_HOME_PRODUCTS_DATA = 'REQUEST_HOME_PRODUCTS_DATA'
export const SET_HOME_PRODUCTS_DATA = 'SET_HOME_PRODUCTS_DATA'
export const SET_HOME_PRODUCTS_STATE = 'SET_HOME_PRODUCTS_STATE'

// 商品列表
export const REQUEST_PRODUCT_LIST_DATA = 'REQUEST_PRODUCT_LIST_DATA'
export const SET_PRODUCT_LIST_DATA = 'SET_PRODUCT_LIST_DATA'
export const SET_PRODUCT_LIST_STATE = 'SET_PRODUCT_LIST_STATE'
export const SET_PRODUCT_LIST_INDEX = 'SET_PRODUCT_LIST_INDEX'
export const CLEAR_PRODUCT_LIST_SEARCH = 'CLEAR_PRODUCT_LIST_SEARCH'

// 商品详情
export const REQUEST_PRODUCT_DETAILS_DATA = 'REQUEST_PRODUCT_DETAILS_DATA'
export const SET_PRODUCT_DETAILS_DATA = 'SET_PRODUCT_DETAILS_DATA'
export const SET_PRODUCT_DETAILS_STATE = 'SET_PRODUCT_DETAILS_STATE'

// 购物车
export const REQUEST_CART_DATA = 'REQUEST_CART_DATA'
export const SET_CART_DATA = 'SET_CART_DATA'
export const SET_CART_STATE = 'SET_CART_STATE'
export const POST_CART_ITEM = 'POST_CART_ITEM'
export const PUT_CART_ITEM = 'PUT_CART_ITEM'
export const DELETE_CART_ITEM = 'DELETE_CART_ITEM'

// 确认订单
export const SET_MALL_ORDER_CONFIRM_DATA = 'SET_MALL_ORDER_CONFIRM_DATA'
export const SET_MALL_ORDER_CONFIRM_COUPON = 'SET_MALL_ORDER_CONFIRM_COUPON'

// 订单列表
export const REQUEST_MALL_ORDER_LIST_DATA = 'REQUEST_MALL_ORDER_LIST_DATA'
export const SET_MALL_ORDER_LIST_DATA = 'SET_MALL_ORDER_LIST_DATA'
export const SET_MALL_ORDER_LIST_STATE = 'SET_MALL_ORDER_LIST_STATE'
export const SET_MALL_ORDER_LIST_INDEX = 'SET_MALL_ORDER_LIST_INDEX'
export const SET_MALL_ORDER_LIST_REFRESH = 'SET_MALL_ORDER_LIST_REFRESH'

// 搜索商品
export const REQUEST_MALL_SEARCH_LIST_DATA = 'REQUEST_MALL_SEARCH_LIST_DATA'
export const SET_MALL_SEARCH_LIST_DATA = 'SET_MALL_SEARCH_LIST_DATA'
export const SET_MALL_SEARCH_LIST_STATE = 'SET_MALL_SEARCH_LIST_STATE'
export const CLEAR_MALL_SEARCH_LIST = 'CLEAR_MALL_SEARCH_LIST'
